import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

export const collection = 'syncedDictionaryCategory'
export const schema = new schemas.Entity(collection)

export const create =
  (callApi: CallApi, apiBase: string) =>
  (
    _: unknown,
    { connectorId, categoryId }: { connectorId: string; categoryId: string }
  ) =>
    callApi(
      `${apiBase}/dictionary/connectors/${connectorId}/actions/sync/${categoryId}`,
      schema,
      {
        method: 'POST',
      }
    )

export const remove =
  (callApi: CallApi, apiBase: string) =>
  (
    _: unknown,
    { connectorId, descriptorId }: { connectorId: string; descriptorId: string }
  ) =>
    callApi(
      `${apiBase}/dictionary/connectors/${connectorId}/actions/sync/${descriptorId}`,
      schema,
      {
        method: 'DELETE',
      }
    )
